<template>
  <div>
    <div>
      <top-menu 
        :backVisible="false"
        :homeVisible="false"
        :aboutVisible="true"
      >
      </top-menu>
    </div>
    <div>
      <v-container fluid class="ma-0 pa-0 mt-6">

        <v-row class="text--center">
          <v-col >
              <v-snackbar outlined top centered :value="updateExists"  :timeout="-1" color="red lighten-2" class="justify-center text--center mt-10">
                
                <div class="text-center justify-center red--text font-weight-bold">
                  Update Available
                <v-btn small rounded color="red darken-4 white--text" @click="refreshApp">
                  Install Now!
                </v-btn></div>
              </v-snackbar>
          </v-col>
        </v-row>
        <v-row v-if="loggedIn == true" dense>
          <v-col class="text-center ma-0 pa-0 mb-6">
            <v-label ><span class="title font-weight-black">{{ selWing }} Modules</span></v-label>
            <br />
          </v-col>
        </v-row>

        <v-row class="justify-center" no-gutters>

          <v-col v-if="menuperms.Menu_AircraftInfo.includes(selWing.toUpperCase()) && loggedIn == true && selWing == userInfo.wing" class="text-center">
            <v-card
              tile
              text
              class="pa-2"
              outlined
            >
              <v-btn color="blue darken-4 " dark :height="btnHeight" :width="btnWidth" to="/aircraftinfo" fab>
                <v-flex class="wrapper">
                  <v-icon medium :class="bottomMargin">mdi-airplane</v-icon>
                  <span :class="textSize">Aircraft<br />Info</span>
                </v-flex>
              </v-btn>
            </v-card>
          </v-col>

          <v-col v-if="menuperms.Menu_Callsigns.includes(selWing.toUpperCase()) && loggedIn == true && selWing == userInfo.wing" class="text-center">
            <v-card
              tile
              text
              class="pa-2"
              outlined
            >
              <v-btn color="brown darken-4" dark :height="btnHeight" :width="btnWidth" to="/CallsignSearch" fab>
                <v-flex class="wrapper">
                  <v-icon medium :class="bottomMargin">mdi-library</v-icon>
                  <span :class="textSize">Call<br />signs</span>
                </v-flex>
              </v-btn>
            </v-card>
          </v-col>

          <v-col v-if="menuperms.Menu_CheckPilots.includes(selWing.toUpperCase()) && loggedIn == true" class="text-center">
            <v-card
              tile
              text
              class="pa-2"
              outlined
            >
              <v-btn color="blue-grey darken-2" dark :height="btnHeight" :width="btnWidth" to="/checkpilotlist" fab>
                <v-flex class="wrapper">
                  <v-icon medium :class="bottomMargin">mdi-account-group</v-icon>
                  <span :class="textSize">Check<br />Pilots</span>
                </v-flex>
              </v-btn>
            </v-card>
          </v-col>

          <!-- <v-col v-if="menuperms.Menu_Covid19.includes(selWing.toUpperCase()) && loggedIn == true" class="text-center">
            <v-card
              tile
              text
              class="pa-2"
              outlined
            >
              <v-btn color="purple accent-3" dark :height="btnHeight" :width="btnWidth" to="/covidselector" fab>
                <v-flex class="wrapper">
                  <v-icon medium :class="bottomMargin">mdi-needle</v-icon>
                  <span :class="textSize">Covid-19</span>
                </v-flex>
              </v-btn>
            </v-card>
          </v-col> -->

          <v-col v-if="menuperms.Menu_Form14.includes(selWing.toUpperCase()) && loggedIn == true && selWing == userInfo.wing" class="text-center">
            <v-card
              tile
              text
              class="pa-2 "
              outlined
            >
              <v-btn color="lime " :height="btnHeight" :width="btnWidth" to="/form14" fab>
                <v-flex class="wrapper">
                  <v-icon medium :class="bottomMargin">mdi-cash-100</v-icon>
                  <span :class="textSize">Form 14</span>
                </v-flex>
              </v-btn>
            </v-card>
          </v-col>

          <v-col v-if="menuperms.Menu_FROList.includes(selWing.toUpperCase()) && loggedIn == true" class="text-center">
            <v-card
              tile
              text
              class="pa-2 "
              outlined
            >
              <v-btn color="green darken-3" dark :height="btnHeight" :width="btnWidth" to="/frolist" fab>
                <v-flex class="wrapper">
                  <v-icon medium :class="bottomMargin">mdi-magnify</v-icon>
                  <span :class="textSize">FRO<br />List</span>
                </v-flex>
              </v-btn>
            </v-card>
          </v-col>

          <v-col v-if="menuperms.Menu_ICList.includes(selWing.toUpperCase()) && loggedIn == true" class="text-center">
            <v-card
              tile
              text
              class="pa-2"
              outlined
            >
              <v-btn color="deep-orange lighten-1" dark :height="btnHeight" :width="btnWidth" to="/iclistselector" fab>
                <v-flex class="wrapper">
                  <v-icon medium :class="bottomMargin">mdi-account-group</v-icon>
                  <span :class="textSize">IC<br />List</span>
                </v-flex>
              </v-btn>
            </v-card>
          </v-col>



          <v-col v-if="menuperms.Menu_MemberInfo.includes(selWing.toUpperCase()) && loggedIn == true" class="text-center">
            <v-card
              tile
              text
              class="pa-2"
              outlined
            >
              <v-btn color="brown lighten-1" dark :height="btnHeight" :width="btnWidth" to="/memberinfo" fab>
                <v-flex class="wrapper">
                  <v-icon medium :class="bottomMargin">mdi-account-search-outline</v-icon>
                  <span :class="textSize">Member<br />Info</span>
                </v-flex>
              </v-btn>
            </v-card>
          </v-col>

          <v-col v-if="menuperms.Menu_MishapReport.includes(selWing.toUpperCase()) && loggedIn == true" class="text-center">
            <v-card
              tile
              text
              class="pa-2"
              outlined
            >
              <v-btn color="red darken-4" dark :height="btnHeight" :width="btnWidth" to="/mishapreport" fab>
                <v-flex class="wrapper">
                  <v-icon medium :class="bottomMargin">mdi-car-brake-alert</v-icon>
                  <span :class="textSize">Mishap<br />Report</span>
                </v-flex>
              </v-btn>
            </v-card>
          </v-col>

          <v-col v-if="menuperms.Menu_MyInfo.includes(selWing.toUpperCase()) && loggedIn == true && selWing == userInfo.wing" class="text-center">
            <v-card
              tile
              text
              class="pa-2"
              outlined
            >
              <v-btn color="purple darken-4" dark :height="btnHeight" :width="btnWidth" :to="`/memberinfo/type/email/${this.userInfo.email}`" fab>
                <v-flex class="wrapper">
                  <v-icon medium :class="bottomMargin">mdi-card-account-details-outline</v-icon>
                  <span :class="textSize">My<br />Info</span>
                </v-flex>
              </v-btn>
            </v-card>
          </v-col>

          <!-- <v-col v-if="menuperms.Menu_PosRpt.includes(selWing.toUpperCase()) && loggedIn == true" class="text-center">
            <v-card
              tile
              text
              class="pa-2"
              outlined
            >
              <v-btn color="deep-orange lighten-4" :height="btnHeight" :width="btnWidth" to="/positionreport" fab>
                <v-flex class="wrapper">
                  <v-icon medium :class="bottomMargin">mdi-crosshairs-gps</v-icon>
                  <span :class="textSize">Position<br />Report</span>
                </v-flex>
              </v-btn>
            </v-card>
          </v-col> -->

          <v-col v-if="menuperms.Menu_SkillEvaluator.includes(selWing.toUpperCase()) && loggedIn == true" class="text-center">
            <v-card
              tile
              text
              class="pa-2"
              outlined
            >
              <v-btn color="red accent-1" :height="btnHeight" :width="btnWidth" :to="'/skillevaluator'" fab>
                <v-flex class="wrapper">
                  <v-icon medium :class="bottomMargin">mdi-cards-diamond</v-icon>
                  <span :class="textSize">SET<br />List</span>
                </v-flex>
              </v-btn>
            </v-card>
          </v-col>

          <!-- <v-col v-if="menuperms.Menu_SpecDC.includes(selWing.toUpperCase()) && loggedIn == true" class="text-center">
            <v-card
              tile
              text
              class="pa-2"
              outlined
            >
              <v-btn color="pink darken-4" dark :height="btnHeight" :width="btnWidth" to="/SpecialtyDataCollector" fab>
                <v-flex class="wrapper">
                  <v-icon medium :class="bottomMargin">mdi-database-plus-outline</v-icon>
                  <span :class="textSize">Specialty<br />Data</span>
                </v-flex>
              </v-btn>
            </v-card>
          </v-col> -->

          <v-col v-if="menuperms.Menu_SpecialtyTracks.includes(selWing.toUpperCase()) && loggedIn == true" class="text-center">
            <v-card
              tile
              text
              class="pa-2"
              outlined
            >
              <v-btn color="pink accent-1" :height="btnHeight" :width="btnWidth" :to="'/spectracks'" fab>
                <v-flex class="wrapper">
                  <v-icon medium :class="bottomMargin">mdi-podium</v-icon>
                  <span :class="textSize">Spec<br />Tracks</span>
                </v-flex>
              </v-btn>
            </v-card>
          </v-col>

          <v-col v-if="menuperms.Menu_StaffList.includes(selWing.toUpperCase()) && loggedIn == true" class="text-center">
            <v-card
              tile
              text
              class="pa-2"
              outlined
            >
              <v-btn color="yellow accent-3" :height="btnHeight" :width="btnWidth" :to="unitswithgroups.includes(selWing.toUpperCase()) ? '/staffdirectory' : '/staffdirectory/ALL'" fab>
                <v-flex class="wrapper">
                  <v-icon medium :class="bottomMargin">mdi-account-search</v-icon>
                  <span :class="textSize">Staff<br />List</span>
                </v-flex>
              </v-btn>
            </v-card>
          </v-col>

          <v-col v-if="menuperms.Menu_Told.includes(selWing.toUpperCase()) && loggedIn == true && selWing == userInfo.wing" class="text-center">
            <v-card
              tile
              text
              class="pa-2"
              outlined
            >
              <v-btn color="light-blue darken-1" dark :height="btnHeight" :width="btnWidth" to="/told" fab>
                <v-flex class="wrapper">
                  <v-icon medium :class="bottomMargin">mdi-calculator</v-icon>
                  <span :class="textSize">T O L D</span>
                </v-flex>
              </v-btn>
            </v-card>
          </v-col>

          <v-col v-if="(menuperms.Menu_WMAO.includes(selWing.toUpperCase()) && loggedIn == true) && selWing == userInfo.wing" class="text-center">
            <v-card
              tile
              text
              class="pa-2"
              outlined
            >
              <v-btn color="deep-purple lighten-4" light :height="btnHeight" :width="btnWidth" to="/wmao" fab>
                <v-flex class="wrapper">
                  <v-icon medium :class="bottomMargin">mdi-head-alert-outline</v-icon>
                  <span :class="textSize">WMAO</span>
                </v-flex>
              </v-btn>
            </v-card>
          </v-col>

          <v-col v-if="(menuperms.Menu_Login.includes(selWing.toUpperCase()) && loggedIn == false) || selWing.toUpperCase() == 'NONE' && ($vars.AppEnvironment == 'dev' || $vars.AppEnvironment =='local')" class="text-center">
            <v-card
              tile
              text
              class="pa-2"
              outlined
            >
              <v-btn color="pink lighten-4" light :height="btnHeight" :width="btnWidth" to="/" fab>
                <v-flex class="wrapper">
                  <v-icon medium :class="bottomMargin">mdi-location-enter</v-icon>
                  <span :class="textSize">Login</span>
                </v-flex>
              </v-btn>
            </v-card>
          </v-col>


          <v-col class="text-center">
            <v-card
              tile
              text
              class="pa-2"
              outlined
            >
              <v-btn color="black" dark :height="btnHeight" :width="btnWidth" to="/" fab>
                <v-flex class="wrapper">
                  <v-icon medium :class="bottomMargin">mdi-backburger</v-icon>
                  <span :class="textSize">Select<br />Wing</span>
                </v-flex>
              </v-btn>
            </v-card>
          </v-col>

            <!-- <v-col v-if="menuperms.Menu_Logout.includes(selWing.toUpperCase()) && loggedIn == true" class="text-center">
              <v-card
                tile
                text
                class="pa-2"
                outlined
              >
                <v-btn color="pink lighten-4" light :height="btnHeight" :width="btnWidth" to="/logout" fab>
                  <v-flex class="wrapper">
                    <v-icon medium :class="bottomMargin">mdi-location-exit</v-icon>
                    <span :class="textSize">Logout</span>
                  </v-flex>
                </v-btn>
              </v-card>
            </v-col> -->
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//import { mapState } from 'vuex';

export default {
  name: 'home',
  components: {
  },
  data () {
    return {
      btnHeight:'80px',
      btnWidth:'80px',
      aboutModalVisible: false,
      textSize:"text-caption",
      bottomMargin:"mb-0"
    }
  },
  mounted() {
    this.setBackButtonVisibility(false);
    this.setHomeButtonVisibility(false);
  },
  computed: {
    //  ...mapState({
    //   // arrow functions can make the code very succinct!
    //   loggedIn: state => state.userinfo.loggedIn,
    //   userInfo: state => state.userinfo.cognitoInfo
    // })
  }
}
</script>

<style scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

</style>
